export default __webpack_public_path__ + "eca524e6c68765b6ec076aadd135f612.wav";